<template>
  <div class="media-options">
    <div>
      <label for="mediaMinInput" class="media-label">
        {{ $t("maintenance.number_config.min") }}
      </label>
      <input
        id="mediaMinInput"
        :placeholder="$t('maintenance.min')"
        type="number"
        min="0"
        step="1"
        class="input-number"
        :class="{ 'is-invalid': hasMinError }"
        v-model.number="model.data.min"
        @input="validateMediaConfig"
      >
      <div v-if="hasMinError" class="invalid-feedback d-block">
        {{ minErrorMessage }}
      </div>
    </div>
    <div>
      <label for="mediaMaxInput" class="media-label">
        {{ $t("maintenance.number_config.max") }}
      </label>
      <input
        id="mediaMaxInput"
        :placeholder="$t('maintenance.max')"
        type="number"
        min="1"
        step="1"
        class="input-number"
        :class="{ 'is-invalid': hasMaxError }"
        v-model.number="model.data.max"
        @input="validateMediaConfig"
      >
      <div v-if="hasMaxError" class="invalid-feedback d-block">
        {{ maxErrorMessage }}
      </div>
    </div>
    <div class="crop-option">
      <b-form-checkbox v-model="model.data.canCrop">
        {{ $t("maintenance.can_crop") }}
      </b-form-checkbox>
    </div>
  </div>
</template>
<script>
const TYPE = "media";
const MODEL = {
  data: {
    min: null,
    max: null,
    canCrop: false
  }
};

export default {
  props: {
    data: Object,
    config: Object
  },
  data() {
    return {
      model: JSON.parse(JSON.stringify(MODEL)),
      minErrorMessage: "",
      maxErrorMessage: ""
    };
  },
  computed: {
    hasMinError() {
      return this.minErrorMessage !== "";
    },
    hasMaxError() {
      return this.maxErrorMessage !== "";
    },
    isValid() {
      return this.minErrorMessage === "" && this.maxErrorMessage === "";
    }
  },
  created() {
    const currentData =
      this.data &&
      this.data.data &&
      typeof this.data.data === "object" &&
      !Array.isArray(this.data.data)
        ? this.data.data
        : {};
    const isMediaType = TYPE === this.config.type;
    if (isMediaType) {
      this.model = {
        data: {
          min: currentData.min !== undefined ? currentData.min : null,
          max: currentData.max !== undefined ? currentData.max : null,
          canCrop: currentData.canCrop === true
        }
      };
    }
    this.validateMediaConfig();
  },
  methods: {
    validateMediaConfig() {
      this.minErrorMessage = "";
      this.maxErrorMessage = "";
      const minValue = this.model.data.min;
      const maxValue = this.model.data.max;
      const isMinEmpty =
        minValue === null ||
        minValue === undefined ||
        minValue === "";
      const isMaxEmpty =
        maxValue === null ||
        maxValue === undefined ||
        maxValue === "";
      if (isMinEmpty) {
        this.minErrorMessage = this.$t("maintenance.media_config.min_required");
      }
      if (isMaxEmpty) {
        this.maxErrorMessage = this.$t("maintenance.media_config.max_required");
      }
      if (!isMinEmpty && (!Number.isInteger(Number(minValue)) || Number(minValue) < 0)) {
        this.minErrorMessage = this.$t("maintenance.media_config.min_non_negative_integer");
      }
      if (!isMaxEmpty && (!Number.isInteger(Number(maxValue)) || Number(maxValue) < 1)) {
        this.maxErrorMessage = this.$t("maintenance.media_config.max_greater_than_zero");
      }
      if (
        !isMinEmpty &&
        !isMaxEmpty &&
        Number.isInteger(Number(minValue)) &&
        Number.isInteger(Number(maxValue)) &&
        Number(minValue) > Number(maxValue)
      ) {
        this.minErrorMessage = this.$t("maintenance.media_config.min_not_greater_than_max");
        this.maxErrorMessage = this.$t("maintenance.media_config.max_not_less_than_min");
      }
      this.$emit("validation-changed", this.isValid);
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit("update:data", val);
        this.validateMediaConfig();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.media-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  margin: auto;
}
.media-label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #1b3d5e;
}
.input-number {
  padding: .4rem;
  border-radius: 4px;
  border: .1rem solid #1b3d5e;
  outline: none;
  width: 100%;
}
.input-number.is-invalid {
  border-color: #dc3545;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.crop-option {
  grid-column: 1 / -1;
  padding-top: 5px;
}
</style>
